// extracted by mini-css-extract-plugin
export default {"socialLogin":"SocialLogin_socialLogin__iHNdb","loginError":"SocialLogin_loginError__YVJcI","googleButton":"SocialLogin_googleButton__gT-XK"};